<template>
    <!-- <b-modal v-model="modalShow" hide-footer> -->
        <div>
        <!-- <form method="post" autocomplete="off" enctype="multipart/form-data"> -->
            <div class="row pt-2">
                <div class="col-sm-12 col-md-12 text-center">
                    <h5>{{ title ? title : 'Are you sure you want to confirm?' }}</h5>
                </div>
            </div>
            <div class="row pt-2">
              <div class="col-sm-12 col-md-12 text-left">
                <label for="note">Note:</label>
                <textarea 
                  v-model="note"
                  class="form-control"
                  rows="5"
                  placeholder="Please type your note here"
                >Please type your note here</textarea>
              </div>
            </div>
            <div class="float-right">
                <button type="submit" class="mt-5 btn btn-outline-orange text-orange text-uppercase mr-2" @click="confirmFunc">{{ btnText ? btnText : 'Yes' }}</button>
                <button type="submit" class="mt-5 btn btn-outline-orange text-orange text-uppercase" @click="closeModal">Cancel</button>
            </div>
        <!-- </form> -->
        </div>
    <!-- </b-modal> -->
</template>

<script>

export default {
  props: ['title', 'btnText'],
	emits: ['customFunc','closeModal'],
  data() {
    return {
      note: '',
    }
  },
	components: {
	},
    setup(){
		
	}, 
	data() {
		return {
		}
	},
    mounted() {
        
    },
	methods: {
		confirmFunc() {
            this.$emit('customFunc', this.note)
            this.$emit('closeModal')
		},
        closeModal() {
            this.$emit('closeModal')
        }
	}
}
</script>